import { Component, Input, OnInit, inject } from '@angular/core';
import { Encounter } from 'app/core/models/encounter.model';
import { Patient } from 'app/core/models/patient.model';
import { PatientService } from 'app/core/services/patient.service';
import { NgTemplateOutlet, NgClass, DatePipe } from '@angular/common';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
    selector: 'app-client-task-encounters',
    templateUrl: './client-task-encounters.component.html',
    styleUrls: ['./client-task-encounters.component.scss'],
    imports: [NgTemplateOutlet, NgClass, MatProgressSpinner, DatePipe]
})
export class ClientTaskEncountersComponent implements OnInit {
  private patientService = inject(PatientService);

  _patient: Patient;
  patientId: number = null;

  eligibleEncounters: Encounter[] = [];
  ineligibleEncounters: Encounter[] = [];
  currentTab = 'eligibleEncounters';
  showIneligibleEncounters = false;
  moreEncountersThanDisplayed = false;

  loadingEncounters = true;

  ngOnInit() {
    this.init();
  }

  get patient(): Patient {
    return this._patient;
  }

  @Input()
  set patient(patient: Patient) {
    this._patient = patient;

    if (this.patientId !== patient.id) {
      this.patientId = patient.id;
      this.loadEncounters();
    }
  }

  private init() {
    this.loadEncounters();
  }

  private loadEncounters() {
    this.loadingEncounters = true;

    this.patientService.getEncounters(this.patient.id).subscribe(result => {
      this.loadingEncounters = false;

      if (result.meta.eligibilityBasedOnLocation) {
        this.showIneligibleEncounters = true;

        this.eligibleEncounters =
          result.encounters.filter(encounter => encounter.locationEligibleDuringServiceDate);

        this.ineligibleEncounters =
          result.encounters.filter(encounter => !encounter.locationEligibleDuringServiceDate);
      } else {
        this.showIneligibleEncounters = false;
        this.eligibleEncounters = result.encounters;
      }
      if (result.meta.paging.count > result.meta.paging.pageSize) {
        this.moreEncountersThanDisplayed = true;
      } else {
        this.moreEncountersThanDisplayed = false;
      }
    });
  }

  tabClick($event, tabName) {
    $event.preventDefault();
    this.currentTab = tabName;
  }
}
